import { createReducer, on } from '@ngrx/store';
import { SharedState } from '../models/shared.model';
import { confirmationChange, openConfirmationModal, OpenSidePanelForCreation } from '../actions/shared.actions';
import { EditRecipe } from '../actions/search.actions';

const initialState: SharedState = {
  key: '',
  displayedName: '',
  recipeSource: '',
  actionType: null,
  confirmationMatch: false,
};

export const SharedReducer = createReducer(
  initialState,
  on(OpenSidePanelForCreation, (state, { key, displayedName }) => ({
    ...state,
    key,
    displayedName,
  })),
  on(EditRecipe, (state, { row }) => ({
    ...state,
    key: row.recipeType,
  })),
  on(openConfirmationModal, (state, { actionType, recipeSource }) => ({
    ...state,
    actionType,
    recipeSource,
  })),
  on(confirmationChange, (state, { value }) => ({
    ...state,
    confirmationMatch: value === 'CONFIRM' ? true : false,
  })),
);
